require('./bootstrap');

import $ from 'jquery';

import FileInput from './modules/fileinput';
import SelectTwo from './modules/select2';
import initModalConfirmation from './modules/modal-confirmation';

import 'select2';
import 'daterangepicker';
import sortable from 'jquery-ui/ui/widgets/sortable';


require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.print.js');


require('chart.js/dist/chart.min');
require('jquery-toast-plugin/dist/jquery.toast.min');





import tippy from 'tippy.js';

window.ClipboardJS = require('clipboard');
window.bootbox = require('bootbox');
window.tippy = tippy;
window.common = require('./modules/common');
window.gmjs = require('./modules/gmjs');
window.datatables = require('./modules/databales');
window.short = require('./modules/short');


import ClassicEditor from '@ckeditor/ckeditor5-build-classic';



$(function () {
    FileInput();
    SelectTwo();
    initModalConfirmation();



    var scroll = $(window).scrollTop();
    if (scroll > 100) {
        $('#navbar-home').removeClass('bg-transparent');
    } else {
        $('#navbar-home').addClass('bg-transparent');
    }

    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        if (scroll > 100) {
            $('#navbar-home').removeClass('bg-transparent');
        } else {
            $('#navbar-home').addClass('bg-transparent');
        }
    });



    $('body .js-tooltip, [data-toggle="tooltip"]').tooltip({
        html: true
    });

    tippy('.js-lead-tooltip', {
        // default
        // parse `content` strings as HTML
        theme: 'light',
        allowHTML: true,
    });

    $('.btn-copy-clipboard').tooltip({trigger: 'click', placement: 'top'});

    function setTooltip(btn, message) {
        $(btn).tooltip('hide')
            .attr('data-original-title', message)
            .tooltip('show');
    }

    function hideTooltip(btn) {
        setTimeout(function() {
            $(btn).tooltip('hide');
        }, 1000);
    }


    var clipboardJs = new ClipboardJS('.btn-copy-clipboard');
    clipboardJs.on('success', function(e) {
        setTooltip(e.trigger, 'Copied!');
        hideTooltip(e.trigger);
    });
    clipboardJs.on('error', function(e) {
        setTooltip(e.trigger, 'Failed!');
        hideTooltip(e.trigger);
    });

    $('form .nav-link:not(.no-errors)').each(function(){
        let errors = $($(this).attr('href') + ' .invalid-feedback').length;
        if (errors) {
            let badge = ` <span class="badge badge-danger">${errors}</span>`;
            $(this).append(badge).addClass('text-danger');
        }
    });

    if ($('.wysiwyg-simple').length) {
        ClassicEditor

            .create(document.querySelector('.wysiwyg-simple'), {
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'undo',
                        'redo'
                    ]
                }
            })
            .catch( error => {
                console.error( error );
            } );
    }

    if ($('.wysiwyg-simple-two').length) {
        ClassicEditor

            .create(document.querySelector('.wysiwyg-simple-two'), {
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'undo',
                        'redo'
                    ]
                }
            })
            .catch( error => {
                console.error( error );
            } );
    }



});

document.addEventListener('DOMContentLoaded', function() {
    function scrollToTarget(targetElement) {
        if (targetElement) {
            const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    }

    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    anchorLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            const targetId = link.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            scrollToTarget(targetElement);
            history.pushState(null, null, targetId);
        });
    });

    // Scroll to target if the URL contains an anchor
    const currentHash = window.location.hash;
    if (currentHash) {
        const targetId = currentHash.replace(/\/#/, '#'); // Remove trailing slash if present
        const initialTarget = document.querySelector(targetId);
        scrollToTarget(initialTarget);
    }

    // Scroll smoothly when navigating with back/forward buttons
    window.addEventListener('popstate', function() {
        const newHash = window.location.hash;
        if (newHash) {
            const targetId = newHash.replace(/\/#/, '#'); // Remove trailing slash if present
            const newTarget = document.querySelector(targetId);
            scrollToTarget(newTarget);
        }
    });
});
